// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#scitani-2021-root .map-wrap{width:50%;height:400px;border:1px solid silver}#scitani-2021-root .map-wrap.loading{width:0;height:0;border:0}#scitani-2021-root .example-buttons{width:250px;height:400px;display:flex;flex-direction:column;justify-content:flex-start}#scitani-2021-root .example-buttons>button{margin:20px;padding:10px}\n", ""]);
// Exports
module.exports = exports;
